import React from "react";
import {observer} from "mobx-react-lite";
import {useNavigate} from "react-router-dom";
import {Tag} from "primereact/tag";
import appStore from "../../../storage/AppStore";
import Btn from "../../../ui/Btn";
import "../../../common/game.css";
import "../../../common/billing.css";

const Debts = ({debts, url}) => {
    const navigate = useNavigate();

    if (!Array.isArray(debts) || debts.length === 0) return null;

    const total = debts.reduce((sum, debt) => sum + Number(debt?.amount || 0), 0);
    const currencySign = debts.find(debt => debt?.currency?.sign)?.currency?.sign || "";

    const getTitle = (debt) => debt?.billing_group?.name || debt?.description || debt?.billing_type?.name || appStore.tr.billing;

    return (
        <div className="game-card debts-card">
            <div className="debts-header">
                <div>
                    <div className="debts-title">{appStore.tr.debts}</div>
                    <div className="text-500 text-sm mt-1">{debts.length}</div>
                </div>
                <div className="debts-total">{total} {currencySign}</div>
            </div>

            <div>
                {debts.map((debt) => {
                    const title = getTitle(debt);
                    const objectName = debt?.object?.name;
                    const billingTypeName = debt?.billing_type?.name;

                    return (
                        <div key={debt.id} className="billing-card">
                            <div className="billing-top">
                                <div className="billing-main">
                                    <div className="billing-title">{title}</div>
                                    <div className="billing-sub">
                                        {billingTypeName}
                                        {objectName && objectName !== title && <span>, {objectName}</span>}
                                    </div>
                                    {debt?.company_user?.title && (
                                        <div className="flex align-items-center mt-2 text-600 text-sm">
                                            <i className="pi pi-user mr-2"/>
                                            <span>{debt.company_user.title}</span>
                                        </div>
                                    )}
                                </div>

                                <div className="billing-side">
                                    <div className="billing-amount text-red-500">
                                        {debt?.amount || 0}{debt?.currency?.sign || ""}
                                    </div>
                                    <div className="billing-status">
                                        <Tag severity="danger" value={appStore.tr.unpaid}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className="flex justify-content-end mt-2">
                <Btn
                    icon="pi pi-dollar"
                    label={appStore.tr.billing}
                    severity="danger"
                    outlined
                    onClick={() => navigate(url)}
                />
            </div>
        </div>
    );
};

export default observer(Debts);
